// deno-lint-ignore-file ban-unused-ignore no-explicit-any no-empty-interface
///////////////////////////////////
// !!! DO NOT EDIT THIS FILE !!! //
///////////////////////////////////

import type { SlackAPIResponse } from "../response";
export type MigrationExchangeResponse = SlackAPIResponse & {
  enterprise_id?: string;
  error?: string;
  invalid_user_ids?: string[];
  needed?: string;
  ok: boolean;
  provided?: string;
  team_id?: string;
  user_id_map?: { [key: string]: string };
  warning?: string;
};
